import { ControlPosition, MapControl } from "@vis.gl/react-google-maps";
import useCommonMap from "../../hooks/useCommonMap";
import GroupSelector from "../groupSelector/GroupSelector";

const TrackingSearch = ({ report }) => {
  const { map, setCurrent } = useCommonMap();

  const onSelect = (selected) => {
    if (!selected || !selected.id) return;

    setCurrent(selected);

    if (
      (selected.type === "assets" || selected.type === "people") &&
      selected.lastPosition &&
      selected.lastPosition.latitude &&
      selected.lastPosition.longitude &&
      map
    ) {
      map.panTo({
        lat: Number(selected.lastPosition.latitude),
        lng: Number(selected.lastPosition.longitude),
      });
      map.setZoom(18);
    } else if (
      selected.type === "zones" &&
      selected.longitude &&
      selected.latitude
    ) {
      map.panTo({
        lat: Number(selected.latitude),
        lng: Number(selected.longitude),
      });
      // map.setCenter({ lat: Number(e.latitude), lng: Number(e.longitude) });
      // centerRef.current = { lat: Number(e.latitude), lng: Number(e.longitude) };
      map.setZoom(16);
    }
  };

  return (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <GroupSelector
        onSelect={onSelect}
        report={report}
        style={{ position: "relative" }}
      ></GroupSelector>
    </MapControl>
  );
};

export default TrackingSearch;
